import { render, staticRenderFns } from "./IframeView.vue?vue&type=template&id=58a1ba04"
import script from "./IframeView.vue?vue&type=script&lang=js"
export * from "./IframeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports